import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import type { Observable } from 'rxjs';
import { map } from 'rxjs';
import type { SharedEntityInterface, ShareTargetType } from '../models/shared-study.interface';

export const GetEntitySharesQuery = gql`query sharedEntities ($entityId: Long!, $isStudy: Boolean!) {
  sharedEntities(entityId: $entityId, isStudy : $isStudy) {
     id
     targetName,
     shareTargetType
     targetId
     userRole
     clinicName
 }
}`;
export let GetEntitySharesQueryVariables: any = null;

@Injectable({
  providedIn: 'root'
})
export class StudyShareService {
  constructor(private readonly apollo: Apollo) { }

  getEntityShares(entityId: number, isStudy: boolean ): Observable<SharedEntityInterface[]> {
    GetEntitySharesQueryVariables =  { entityId, isStudy };
    return this.apollo.query<GetEntitySharesQueryInterface>({
      query: GetEntitySharesQuery,
      variables: GetEntitySharesQueryVariables
    }).pipe(map(res => res.data.sharedEntities));
  }

  deleteShare(id: number, shareTargetType: ShareTargetType): Observable<number | undefined> {
    return this.apollo.mutate<{
      deleteShare: number;
    }>({
      mutation: gql`mutation deleteShare($id : Long!, $shareTargetType : ShareTargetType!)
          {
            deleteShare(id : $id, shareTargetType: $shareTargetType)
          }`,
      variables:
      {
        id,
        shareTargetType
      },
      update: (store, { data }) => {
        // Read the data from our cache for this query.
        const getEntitySharesQuery = store.readQuery<GetEntitySharesQueryInterface>({ query: GetEntitySharesQuery, variables: GetEntitySharesQueryVariables });
        if (getEntitySharesQuery) {
          let shares = getEntitySharesQuery.sharedEntities.map(shares => ({ ...shares }));
          shares = shares.filter(a => a.id !== data?.deleteShare);
          store.writeQuery<GetEntitySharesQueryInterface>({ query: GetEntitySharesQuery, data: { sharedEntities :shares }, variables: GetEntitySharesQueryVariables });
        }
      },
      refetchQueries: [
        {
          query: GetEntitySharesQuery,
          variables: GetEntitySharesQueryVariables
        }]
    }).pipe(map(res => res.data ? res.data?.deleteShare : undefined));
  }
}

export interface GetEntitySharesQueryInterface {
  sharedEntities: SharedEntityInterface[];
}
